import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "mt-8" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "text-xl px-4 py-2 text-gray-400" }, "PAYTR Payments", -1)
const _hoisted_3 = { class: "flex flex-col space-y-2 w-full p-8" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "text-center" }, "Id"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-center" }, "Users e-Mail"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-center" }, "Users Name"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-right" }, "Amount"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-right" }, "Created"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-center" }, "Payment Type"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-center" }, "Receipt Type"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-center" }, "Actions")
  ])
], -1)
const _hoisted_5 = { class: "text-center" }
const _hoisted_6 = { class: "text-center" }
const _hoisted_7 = { class: "text-center" }
const _hoisted_8 = { class: "text-right" }
const _hoisted_9 = { class: "text-right" }
const _hoisted_10 = { class: "text-center" }
const _hoisted_11 = { class: "text-center" }
const _hoisted_12 = { class: "text-center" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { key: 1 }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "p-5" }, null, -1)
const _hoisted_16 = {
  key: 2,
  class: "flex space-x-6 border border-gray-200"
}
const _hoisted_17 = { class: "table-auto m-4" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("td", { class: "text-right font-medium" }, "Id", -1)
const _hoisted_19 = { class: "text-left pl-4" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("td", { class: "text-right font-medium" }, "Receipt Id", -1)
const _hoisted_21 = { class: "text-left pl-4" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("td", { class: "text-right font-medium" }, "Payment Type", -1)
const _hoisted_23 = { class: "text-left pl-4" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("td", { class: "text-right font-medium" }, "Receipt Type", -1)
const _hoisted_25 = { class: "text-left pl-4" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("td", { class: "text-right font-medium" }, "Company Tax No", -1)
const _hoisted_27 = { class: "text-left pl-4" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("td", { class: "text-right font-medium" }, "Company Tax Office", -1)
const _hoisted_29 = { class: "text-left pl-4" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("td", { class: "text-right font-medium" }, "Citizenship No", -1)
const _hoisted_31 = { class: "text-left pl-4" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("td", { class: "text-right font-medium" }, "City", -1)
const _hoisted_33 = { class: "text-left pl-4" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("td", { class: "text-right font-medium" }, "Country", -1)
const _hoisted_35 = { class: "text-left pl-4" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("td", { class: "text-right font-medium" }, "Address", -1)
const _hoisted_37 = { class: "text-left pl-4" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("td", { class: "text-right font-medium" }, "First Name", -1)
const _hoisted_39 = { class: "text-left pl-4" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("td", { class: "text-right font-medium" }, "Last Name", -1)
const _hoisted_41 = { class: "text-left pl-4" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("td", { class: "text-right font-medium" }, "Zip Code", -1)
const _hoisted_43 = { class: "text-left pl-4" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("td", { class: "text-right font-medium" }, "Last 4 Digits", -1)
const _hoisted_45 = { class: "text-left pl-4" }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("td", { class: "text-right font-medium" }, "Package Name", -1)
const _hoisted_47 = { class: "text-left pl-4" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("td", { class: "text-right font-medium" }, "User License Count", -1)
const _hoisted_49 = { class: "text-left pl-4" }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("td", { class: "text-right font-medium" }, "Amount", -1)
const _hoisted_51 = { class: "text-left pl-4" }
const _hoisted_52 = /*#__PURE__*/_createElementVNode("td", { class: "text-right font-medium" }, "KDV", -1)
const _hoisted_53 = { class: "text-left pl-4" }
const _hoisted_54 = /*#__PURE__*/_createElementVNode("td", { class: "text-right font-medium" }, "Total", -1)
const _hoisted_55 = { class: "text-left pl-4" }
const _hoisted_56 = /*#__PURE__*/_createElementVNode("td", { class: "text-right font-medium" }, "PayTR Payment Amount", -1)
const _hoisted_57 = { class: "text-left pl-4" }
const _hoisted_58 = /*#__PURE__*/_createElementVNode("td", { class: "text-right font-medium" }, "PayTR Total Amount", -1)
const _hoisted_59 = { class: "text-left pl-4" }
const _hoisted_60 = { class: "flex space-x-2 border-l border-gray-200" }
const _hoisted_61 = { class: "flex flex-col space-y-2 m-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("input", {
      type: "file",
      id: "file",
      ref: "file",
      multiple: "",
      onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleFileUpload())),
      style: {"position":"absolute","top":"-500px"},
      accept: "application/pdf"
    }, null, 544),
    _createElementVNode("div", _hoisted_3, [
      (_ctx.getPayTrPaymentsResult && _ctx.getPayTrPaymentsResult.items)
        ? (_openBlock(), _createElementBlock("table", {
            key: 0,
            class: _normalizeClass(["table-auto", [_ctx.waiting ? 'bg-gradient-to-r from-gray-100 via-gray-50 to-gray-100 text-transparent' : '']])
          }, [
            _hoisted_4,
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getPayTrPaymentsResult.items, (item) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: item.id
                }, [
                  _createElementVNode("td", _hoisted_5, _toDisplayString(item.id), 1),
                  _createElementVNode("td", _hoisted_6, _toDisplayString(item.userEMail), 1),
                  _createElementVNode("td", _hoisted_7, _toDisplayString(item.userDisplayName), 1),
                  _createElementVNode("td", _hoisted_8, _toDisplayString(_ctx.formatDecimal(item.amount) + " TL + " + _ctx.formatDecimal(item.amountKdv) + " TL"), 1),
                  _createElementVNode("td", _hoisted_9, _toDisplayString(item.createdDateString), 1),
                  _createElementVNode("td", _hoisted_10, _toDisplayString(item.paymentTypeString), 1),
                  _createElementVNode("td", _hoisted_11, _toDisplayString(item.receiptTypeString), 1),
                  _createElementVNode("td", _hoisted_12, [
                    _createElementVNode("button", {
                      class: "btn-one",
                      onClick: ($event: any) => (_ctx.openDetails(item))
                    }, "Details", 8, _hoisted_13)
                  ])
                ]))
              }), 128))
            ])
          ], 2))
        : (_openBlock(), _createElementBlock("div", _hoisted_14, "No Record.")),
      _hoisted_15,
      (_ctx.selectedItem)
        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
            _createElementVNode("table", _hoisted_17, [
              _createElementVNode("tbody", null, [
                _createElementVNode("tr", null, [
                  _hoisted_18,
                  _createElementVNode("td", _hoisted_19, _toDisplayString(_ctx.selectedItem.id), 1)
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_20,
                  _createElementVNode("td", _hoisted_21, _toDisplayString(_ctx.selectedItem.receiptId), 1)
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_22,
                  _createElementVNode("td", _hoisted_23, _toDisplayString(_ctx.selectedItem.paymentTypeString), 1)
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_24,
                  _createElementVNode("td", _hoisted_25, _toDisplayString(_ctx.selectedItem.receiptTypeString), 1)
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_26,
                  _createElementVNode("td", _hoisted_27, _toDisplayString(_ctx.selectedItem.receiptAddressCompanyTaxNo), 1)
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_28,
                  _createElementVNode("td", _hoisted_29, _toDisplayString(_ctx.selectedItem.receiptAddressCompanyTaxOffice), 1)
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_30,
                  _createElementVNode("td", _hoisted_31, _toDisplayString(_ctx.selectedItem.receiptAddressCitizenshipNo), 1)
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_32,
                  _createElementVNode("td", _hoisted_33, _toDisplayString(_ctx.selectedItem.receiptAddressCityName), 1)
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_34,
                  _createElementVNode("td", _hoisted_35, _toDisplayString(_ctx.selectedItem.receiptAddressCountry), 1)
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_36,
                  _createElementVNode("td", _hoisted_37, _toDisplayString(_ctx.selectedItem.receiptAddressAddress), 1)
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_38,
                  _createElementVNode("td", _hoisted_39, _toDisplayString(_ctx.selectedItem.receiptAddressPersonFirstName), 1)
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_40,
                  _createElementVNode("td", _hoisted_41, _toDisplayString(_ctx.selectedItem.receiptAddressPersonLastName), 1)
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_42,
                  _createElementVNode("td", _hoisted_43, _toDisplayString(_ctx.selectedItem.receiptAddressZipCode), 1)
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_44,
                  _createElementVNode("td", _hoisted_45, _toDisplayString(_ctx.selectedItem.lastFourDigits), 1)
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_46,
                  _createElementVNode("td", _hoisted_47, _toDisplayString(_ctx.selectedItem.purchasedPackageName), 1)
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_48,
                  _createElementVNode("td", _hoisted_49, _toDisplayString(_ctx.selectedItem.userLicenseCount), 1)
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_50,
                  _createElementVNode("td", _hoisted_51, _toDisplayString(_ctx.formatDecimal(_ctx.selectedItem.amount) + " TL"), 1)
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_52,
                  _createElementVNode("td", _hoisted_53, _toDisplayString(_ctx.formatDecimal(_ctx.selectedItem.amountKdv) + " TL"), 1)
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_54,
                  _createElementVNode("td", _hoisted_55, _toDisplayString(_ctx.formatDecimal(_ctx.selectedItem.amount + _ctx.selectedItem.amountKdv) + " TL"), 1)
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_56,
                  _createElementVNode("td", _hoisted_57, _toDisplayString(_ctx.selectedItem.payTrPaymentAmount + " TL"), 1)
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_58,
                  _createElementVNode("td", _hoisted_59, _toDisplayString(_ctx.selectedItem.payTrTotalAmount + " TL"), 1)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_60, [
              _createElementVNode("div", _hoisted_61, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  placeholder: "Receipt No",
                  class: "input-one",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedItem.receiptNumber) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.selectedItem.receiptNumber]
                ]),
                _withDirectives(_createElementVNode("input", {
                  type: "date",
                  placeholder: "Receipt Date",
                  class: "input-one",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedItem.receiptPdfCreationDate) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.selectedItem.receiptPdfCreationDate]
                ]),
                (!_ctx.selectedItem.isReceiptPdfCreated)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      class: "btn-one",
                      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.approve && _ctx.approve(...args)))
                    }, "Approve"))
                  : _createCommentVNode("", true)
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}